export const URL_ACCOUNT_SELECT = '/account/select';
